import React from 'react';
import { connect } from 'react-redux';
import { setShortAction } from './../../services/store/features/appSlice';
import { withStyles } from '@mui/styles';
import { withHOCComponent } from './../../components/hoc/HOCComponent';
import authService from './../../services/auth';

import NotificationsIcon from './../notification/NotificationsIcon';
import IconMenu from './../commons/IconMenu';
import { ChevronLeftIcon, PlusIcon, SettingsIcon, InfoIcon, DeleteIcon, SwapIcon, LogoutIcon, MoreVertIcon } from './../commons/Icons';

import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Container from '@mui/material/Container';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import MenuItem from '@mui/material/MenuItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Divider from '@mui/material/Divider';

class MainHeader extends React.Component {

  constructor (props) {
    super(props);
    this.state = {
      openBottomMenu: false,
      bottomMenuAnchorEl: null,
    };
  }

  logOut (args) {
    authService.logOut();
    this.props.hoc.redirectTo('/' + (args || ''));
  }

  openBottomMenu (event) {
    this.setState({
      openBottomMenu: true,
      bottomMenuAnchorEl: event.currentTarget,
    })
  }

  closeBottomMenu () {
    this.setState({
      openBottomMenu: false,
    })
  }

  setShortAction (shortAction, args = null, callbacks) {
    const { setShortAction } = this.props;
    setShortAction && setShortAction({name: shortAction, args, callbacks});
  }

  closeShortAction = () => {
    const { setShortAction } = this.props;
    setShortAction && setShortAction(null);
  }

  render () {
    const { classes } = this.props;
    return (
      <Box displayPrint="none">
        <AppBar
          elevation={0}
          color="inherit"
          position="fixed"
          className={classes.appBar}>
          <Toolbar className={classes.toolBar}>
            <Container disableGutters={true} maxWidth="md" className={classes.contentainer}>
              { this.render_toolbar() }
            </Container>
          </Toolbar>
        </AppBar>
      </Box>
    );
  }

  render_toolbar_component (edge, cmp, index) {
    if (!cmp || !cmp.el) {
      return null;
    }
    if (cmp.el === 'go-back') {
      return this.render__go_back(edge, index);
    } else if (cmp.el === 'go-home') {
      return this.render__go_home(edge, cmp.args, index);
    } else if (cmp.el === 'notifications') {
      return this.render__go_notifications(edge, cmp.args, index);
    } else if (cmp.el === 'logout') {
      return this.render__logout(edge, cmp.args, index);
    } else if (cmp.el === 'short-action') {
      return this.render__short_action(edge, cmp.icon, cmp.item, index);
    } else if (cmp.el === 'short-actions') {
      return this.render__short_actions(edge, cmp.icon, cmp.items, index);
    }
    return cmp.el
  }

  render_toolbar () {
    const { classes } = this.props;

    let leftComponents = null;
    if (this.props.leftComponents) {
      leftComponents = this.props.leftComponents.map((cmp, index) => this.render_toolbar_component('start', cmp, index));
    }

    let rightComponents = null;
    if (this.props.rightComponents) {
      rightComponents = this.props.rightComponents.map((cmp, index) => this.render_toolbar_component('end', cmp, index));
    }

    return (
      <React.Fragment>
        <Box className={classes.left}>
          {leftComponents}
        </Box>
        <Box className={classes.middle}>
          <Typography variant="h3" component="h1" noWrap className={classes.title}>
            {this.props.title}
          </Typography>
        </Box>
        <Box className={classes.right} id="main-header--right-toolbar">
          {rightComponents}
        </Box>
      </React.Fragment>
    );
  }

  serializeObjectToQueryString (obj) {
    if (!obj || obj === undefined || obj === null ) {
      return '';
    }
    var str = [];
    for (var p in obj)
      if (obj.hasOwnProperty(p)) {
        str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
      }
    return str.join("&");
  }

  render__go_back (edge, index = 0) {
    return (
      <IconButton
        key={index}
        color="inherit"
        aria-label="goback"
        onClick={ () => this.props.hoc.historyGoBack() }
        size="small">
        <ChevronLeftIcon />
      </IconButton>
    );
  }

  render__go_home (edge, args_obj, index = 0) {
    let args = this.serializeObjectToQueryString(args_obj);
    if (args && args !== '') {
      args = '?' + args;
    }
    return (
      <IconButton
        key={index}
        color="inherit"
        aria-label="gohome"
        onClick={ () => this.props.hoc.redirectTo('/' + args) }
        size="small">
        <ChevronLeftIcon />
      </IconButton>
    );
  }

  render__logout (edge, args_obj, index = 0) {
    return (
      <IconButton
        key={index}
        color="inherit"
        aria-label="déconnexion"
        onClick={ () => authService.logOut() }
        size="small">
        <LogoutIcon />
      </IconButton>
    );
  }

  render__go_notifications (edge, args_obj, index = 0) {
    let args = this.serializeObjectToQueryString(args_obj);
    if (args && args !== '') {
      args = '?' + args;
    }
    return (
      <IconButton
        key={index}
        color="inherit"
        aria-label="notifications"
        onClick={ () => this.props.hoc.redirectTo('/profile/notifications' + args) }
        size="small">
        <NotificationsIcon />
      </IconButton>
    );
  }

  render__short_action (edge, icon, action, index = 0) {
    let actionsIcon = icon
    if (icon === 'add') {
      actionsIcon = <PlusIcon />;
    } else if (icon === 'gear') {
      actionsIcon = <SettingsIcon />;
    } else if (icon === 'more') {
      actionsIcon = <MoreVertIcon />;
    }
    return (
      <IconButton
        key={index}
        color="inherit"
        aria-label="action"
        size="small"
        title={action.label}
        onClick={ () => {
          if (action.name === "logout") {
            this.logOut();
          } else if (action.name === "redirectTo") {
            this.props.hoc.redirectTo(action.args?.location)
          } else {
            this.setShortAction(action.name, action.args, {
              onEnd: (...args) => {
                action.onEnd && action.onEnd(this.closeShortAction, ...args)
              },
              onClose: (...args) => {
                action.onClose && action.onClose(...args);
              },
              onError: (...args) => {
                action.onError && action.onError(this.closeShortAction, ...args)
              },
            })
          }
        }}>
        {actionsIcon}
      </IconButton>
    );
  }

  render__short_actions (edge, icon, actions, index = 0) {
    let actionsIcon = icon
    if (icon === 'add') {
      actionsIcon = <PlusIcon />;
    } else if (icon === 'gear') {
      actionsIcon = <SettingsIcon />;
    } else if (icon === 'more') {
      actionsIcon = <MoreVertIcon />;
    }
    return (
      <IconMenu key={index} icon={actionsIcon} iconSize="small" iconColor="inherit" iconAriaLabel="action rapides" render={ () => {
        let items = [];
        if (actions && Array.isArray(actions) && actions.length > 0) {
          let indexItem = 0;
          for (const action of actions) {
            if (action === 'divider') {
              items.push(<Divider key={indexItem} />);
            } else {
              let itemIcon = null;
              if (action.icon === 'add') {
                itemIcon = <PlusIcon />;
              } else if (action.icon === 'delete') {
                itemIcon = <DeleteIcon />;
              } else if (action.icon === 'swap') {
                itemIcon = <SwapIcon />;
              } else if (action.icon === 'info') {
                itemIcon = <InfoIcon />;
              } else {
                itemIcon = action.icon;
              }
              items.push(<MenuItem key={indexItem} onClick={ () => {
                  if (action.name === "logout") {
                    this.logOut();
                  } else if (action.name === "redirectTo") {
                    this.props.hoc.redirectTo(action.args?.location)
                  } else {
                    this.setShortAction(action.name, action.args, {
                      onEnd: (...args) => {
                        action.onEnd && action.onEnd(this.closeShortAction, ...args)
                      },
                      onClose: (...args) => {
                        action.onClose && action.onClose(...args);
                      },
                      onError: (...args) => {
                        action.onError && action.onError(this.closeShortAction, ...args)
                      },
                    })
                  }
                }}>
                  { itemIcon && (<ListItemIcon>{ itemIcon }</ListItemIcon>) }
                  <ListItemText disableTypography={true} primary={ action.label } />
                </MenuItem>
              );
            }
            indexItem ++;
          }
        }
        return items;
      } } />
    );
  }
}

const styles = theme => ({
  appBar: {
    zIndex: theme.zIndex.drawer + 2,
  },
  contentainer: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  left: {
    minWidth: 80,
    display: 'flex',
    justifyContent: 'flex-start',
    marginLeft: theme.spacing(-1),
  },
  middle: {
    maxWidth: 'calc(100% - '+160+')',
    overflow: 'hidden',
  },
  right: {
    minWidth: 80,
    display: 'flex',
    justifyContent: 'flex-end',
    marginRight: theme.spacing(-1),
  },
  title: {
    textAlign: 'center',
    margin: 0,
  },
});

const mapStateToProps = state => ({
	appStore: state.app,
});

const mapDispatchToProps = (dispatch) => {
  return {
    setShortAction: (shortAction) => dispatch(setShortAction(shortAction)),
  }
}

export default withHOCComponent(withStyles(styles, { withTheme: true })(connect(mapStateToProps, mapDispatchToProps)(MainHeader)));
